import { Modal, Table } from 'antd';

export const formatHours = (hours) => {
    if (hours == null) return '-';
    const h = Math.floor(hours);
    const m = Math.floor((hours % 1) * 60);
    const s = Math.floor(((hours % 1) * 60 % 1) * 60);
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

export const SERVICE_LABELS = {
    excavation: 'Excavation Record',
    boring: 'Boring Guidance',
};

export const BILLING_LABELS = {
    hourly: 'Hourly',
    daily: 'Daily',
    full_period: 'Machine Schedule Period',
};

export const usageLogColumns = [
    {
        title: 'Service Name',
        dataIndex: 'log_type',
        key: 'log_type',
        render: (value) => SERVICE_LABELS[value] ?? value,
    },
    {
        title: 'Billing Preference',
        dataIndex: 'billing_preference',
        key: 'billing_preference',
        render: (value) => BILLING_LABELS[value] ?? value,
    },
    {
        title: 'Manifest',
        dataIndex: 'manifest_name',
        key: 'manifest_name',
        render: (value) => value ?? '-',
    },
    {
        title: 'Project',
        dataIndex: 'partner_project',
        key: 'partner_project',
        render: (value) => value ?? '-',
    },
    {
        title: 'Total Hours',
        dataIndex: 'total_hours',
        key: 'total_hours',
        render: (value) => formatHours(value),
    },
    {
        title: 'Total Days',
        dataIndex: 'total_days',
        key: 'total_days',
        render: (value) => value ?? '-',
    },
    {
        title: 'Schedule Start',
        dataIndex: 'schedule_from',
        key: 'schedule_from',
        render: (value, row) => row.billing_preference === 'full_period' && value
            ? new Date(value).toLocaleDateString()
            : '-',
    },
    {
        title: 'Schedule End',
        dataIndex: 'schedule_to',
        key: 'schedule_to',
        render: (value, row) => row.billing_preference === 'full_period' && value
            ? new Date(value).toLocaleDateString()
            : '-',
    },
    {
        title: 'Assignment Date',
        dataIndex: 'assignment_at',
        key: 'assignment_at',
        render: (value) => value ? new Date(value).toLocaleDateString() : '-',
    },
];

const LogServiceUsagesModal = ({ record, onClose }) => {
    return (
        <Modal
            open={Boolean(record)}
            title='Service Usages'
            onCancel={onClose}
            onOk={onClose}
            okText='OK'
            cancelText='Cancel'
            width={1100}
            centered
            maskClosable={false}
        >
            <Table
                rowKey='id'
                dataSource={record?.usage_logs ?? []}
                columns={usageLogColumns}
                pagination={{
                    pageSize: 10,
                    position: ['bottomCenter'],
                    itemRender: (page, type, originalElement) =>
                        type === 'prev' || type === 'next' ? (
                            <span style={{
                                border: '1px solid #377ef3',
                                borderRadius: 5,
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 25,
                                height: 22,
                                margin: '0 8px'
                            }}>
                                {originalElement}
                            </span>
                        ) : originalElement,
                }}
                locale={{ emptyText: 'No data' }}
                size='small'
            />
        </Modal>
    );
};

export default LogServiceUsagesModal;
